// @flow
import React, { PureComponent } from "react";
import classNames from "classnames";

type Props = {
  height: number,
  width: number,
  className: any
};

class Locker extends PureComponent<Props> {
  render() {
    const { height, width, className } = this.props;
    const classes = classNames("icone", className);

    return (
      <svg className={classes} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <title>Ícone cadeado</title>
        <desc>Ícone de um cadeado</desc>
        <g id="icon-locker">
          <path d="M8,0c4,0,4,4,4,4a2.94,2.94,0,0,1,3,3v6a2.94,2.94,0,0,1-3,3H4a2.94,2.94,0,0,1-3-3V7A2.94,2.94,0,0,1,4,4S4,0,8,0Zm2,4A2,2,0,0,0,8,2,2,2,0,0,0,6,4ZM8,12H8a1,1,0,0,0,1-1V9A1,1,0,0,0,8,8H8A1,1,0,0,0,7,9v2A1,1,0,0,0,8,12Z" />
        </g>
      </svg>
    );
  }
}

export default Locker;
